export default (enumVar) => Object.values(enumVar)
    .filter((value) => typeof value === 'number')
    .map((key) => ({
    text: enumVar[key],
    value: key,
}));
